export default "__VITE_ASSET__Aqb84wHW__ 500w";